interface PasswordStrengthResult {
    passed: boolean;
    message: string;
}

/**
 * Checks the strength of a password based on security criteria
 * @param password The password to check
 * @returns Object containing passed status and feedback message
 */
function checkPasswordStrength(password: string): PasswordStrengthResult {
    // Check minimum length
    if (password.length < 8) {
        return {
            passed: false,
            message: "Password must be at least 8 characters long"
        };
    }

    // Check for character variety
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasNumbers = /[0-9]/.test(password);
    const hasSpecialChars = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);

    const requirementsMet = [hasUppercase, hasLowercase, hasNumbers, hasSpecialChars];
    const requirementsCount = requirementsMet.filter(Boolean).length;

    if (requirementsCount < 3) {
        return {
            passed: false,
            message: "Password must contain at least 3 of the following: uppercase letters, lowercase letters, numbers, and special characters"
        };
    }

    // Check for common patterns to avoid
    if (/^12345|password|qwerty|admin|user/i.test(password)) {
        return {
            passed: false,
            message: "Password contains common patterns that are easily guessed"
        };
    }

    // Success case
    return {
        passed: true,
        message: "Password meets strength requirements"
    };
}

export default checkPasswordStrength;